import type { ComplianceAnalysisResult } from '../../../shared/types';

/* Badges de verdict / niveau de risque — pilules pleines du nuancier
 * (aplat pastel + texte encre), comme les étiquettes de la charte. */

export function VerdictBadge({ verdict }: { verdict: ComplianceAnalysisResult['verdict'] | string }) {
  const styles: Record<string, string> = {
    CONFORME: 'bg-khaki-300 text-ink',
    VIGILANCE: 'bg-sun-400 text-ink',
    RISQUE_ELEVE: 'bg-orange-300 text-ink',
    RISQUE_MODERE: 'bg-orange-300 text-ink',
    NON_CONFORME: 'bg-red-300 text-ink',
  };
  const labels: Record<string, string> = {
    CONFORME: 'Conforme',
    VIGILANCE: 'Vigilance',
    RISQUE_ELEVE: 'Risque élevé',
    RISQUE_MODERE: 'Risque élevé',
    NON_CONFORME: 'Non conforme',
  };
  return (
    <span className={`inline-flex items-center rounded-full px-4 py-1.5 text-sm font-semibold ${styles[verdict] ?? 'bg-slate-200 text-ink'}`}>
      {labels[verdict] ?? verdict}
    </span>
  );
}

export function RiskBadge({ level }: { level: string }) {
  const styles: Record<string, string> = {
    'Faible': 'bg-sun-200 text-ink',
    'Moyen': 'bg-orange-200 text-ink',
    'Élevé': 'bg-red-200 text-ink',
  };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${styles[level] ?? 'bg-slate-200 text-ink'}`}>
      {level}
    </span>
  );
}
